import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { handleError } from '../../../contexts/ErrorHandler/errorHandlerPropsMap';
import { IChallengeContext } from '../../../contexts/storage-contexts/Challenge';
import { isPrivateChallenge } from '../../../selectors/isPrivateChallenge';
import { goToVisitorPage } from './goToVisitorPage';
import { prepareUserForPayment } from './prepareUserForPayment';
import { sendJoinRequest } from './sendJoinRequest';

export const createOrderOrSendJoinRequest = async ({
  challengeData,
  flowAPI,
}: {
  challengeData: IChallengeContext['challengeData'];
  flowAPI: ControllerFlowAPI;
}) => {
  try {
    if (isPrivateChallenge(challengeData.challenge)) {
      flowAPI.controllerConfig.setProps({
        isForcedBlankPage: true,
      });

      await sendJoinRequest(flowAPI);

      goToVisitorPage({
        challengeData,
        flowAPI,
      });
    } else {
      flowAPI.controllerConfig.setProps(await prepareUserForPayment(flowAPI));
    }
  } catch (err) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(err);
    handleError({
      error: err,
      resolvedError,
    });
  }
};
